import { ActionReducerMap } from '@ngrx/store';

import { configureCleanReducer, configureSyncReducer, TileAction, TileId } from '@contact/upgrade';

/**
 * Name store feature
 */
export const featureName = 'tracking';

/**
 * Tracking state interface
 */
export interface TrackingState {}

/**
 * Initial Tracking state
 */
export const initialState: TrackingState = {};

/**
 * Tracking reducers map
 */
export const reducers: ActionReducerMap<TrackingState> = {};

const cleanReducer = configureCleanReducer(featureName, {
  initialState,
  keys: [],
  cleanPredicate: action => action.type === TileAction.Reset.type && action.tileId === TileId.USER_TRACKING,
});
const syncReducer = configureSyncReducer(featureName, []);

/**
 * Core meta reducers array
 */
export const metaReducers = [cleanReducer, syncReducer];
